/**
 * API de términos y condiciones de organización usando Axios.
 */
import { axiosInstance } from "features/shared/api";

export const organizationTermsApi = {
    acceptTermsAndConditions: (organizationAddress: string) =>
        axiosInstance.post(
            `/api/organization-terms/accept/${organizationAddress}`
        ),
};
